// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1S2qy","col":"styles_col__NNQwy"};